// import React, { useState,useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   Input,
//   Form,
//   FormGroup,
//   Label,
//   UncontrolledTooltip
// } from "reactstrap";
// import Breadcrumbs from "../../../components/Common/Breadcrumb";

// const KPIFactor = () => {
//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           {/* Breadcrumbs */}
//           <Breadcrumbs title="Setup" breadcrumbItem="KPI Factor" />

//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default KPIFactor;


import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";

const KPIFactor = () => {
  const [data, setData] = useState([
    { id: 1, kpi: "Adhere to HR policy of the organization", isActive: true },
    { id: 2, kpi: "Question paper review, submission & ensuring error free correction", isActive: true },
    { id: 3, kpi: "Individual development - training programme participation, openness to learn and adapt", isActive: true },
    { id: 4, kpi: "Goal Setting & Achievements", isActive: true },
    { id: 5, kpi: "Assessment - Soft/Hard copy - Ensuring and Analysing Error free (Exam/TDE/Co-curricular/ Pathways/ Sports/ Special Events)", isActive: true },
    { id: 6, kpi: "Identifying and Ensure Remedial / Knowledge Ensuring", isActive: true },
    { id: 7, kpi: "Reading Ability / Listening", isActive: true },
    { id: 8, kpi: "Project work & Research paper / Expo - Completion", isActive: true },
    { id: 9, kpi: "Activity Sheet / Selfwork - Error Free Checking to Correction", isActive: true },
    { id: 10, kpi: "Active participation, planning, execution & feedback", isActive: true },
  ]);


  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      kpi: "",
    },
    validationSchema: Yup.object({
      kpi: Yup.string().required("Please Enter Head Name"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (isEdit) {
        setData((prevData) =>
          prevData.map((item) =>
            item.id === editId ? { ...item, ...values } : item
          )
        );
        setIsEdit(false);
        setEditId(null);
      } else {
        const newRow = {
          id: data.length + 1,
          ...values,
          isActive: true,
        };
        setData((prev) => [...prev, newRow]);
      }
      resetForm();
    },
  });

  const handleEdit = (row) => {
    formik.setValues({
      kpi: row.kpi,
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  const handleToggleStatus = (row) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === row.id ? { ...item, isActive: !item.isActive } : item
      )
    );
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => data.length - row.index,      
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "KPI",
      accessor: "kpi",
    },
    {
      Header: "Edit",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        return (
          <Link
            to="#"
            className="text-success"
            onClick={() => handleEdit(cellProps.row.original)}
          >
            <i className="bx bxs-edit font-size-18" id="edittooltip" />
            <UncontrolledTooltip placement="top" target="edittooltip">
              Edit
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
    {
      Header: "Status",
      className: "status-col",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const isActive = cellProps.row.original.isActive;
        return (
          <Link
            to="#"
            style={{ color: isActive ? "green" : "red" }}
          >
            <i
              className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"
                } font-size-18`}
              id={`status-tooltip-${cellProps.row.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`status-tooltip-${cellProps.row.id}`}
            >
              {isActive ? "Active" : "Inactive"}
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Performance" breadcrumbItem="KPI" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  <Col md="6">
                    <FormGroup>
                      <Label for="kpi">
                        KPI <span className="text-danger">*</span></Label>
                      <Input
                        id="kpi"
                        name="kpi"
                        type="text"
                        value={formik.values.kpi}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.kpi &&
                          Boolean(formik.errors.kpi)
                        }
                      />
                      {formik.touched.kpi && formik.errors.kpi && (
                        <div className="text-danger">{formik.errors.kpi}</div>
                      )}

                    </FormGroup>
                  </Col>
                  <Col md="6" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className="btn button-save me-2">
                      <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" className="btn button-cancel" onClick={handleCancel}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data}
                isGlobalFilter={true}
                customPageSize={10}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default KPIFactor;
